import {
  FETCH_COMPANY_PENDING,
  FETCH_COMPANY_SUCCESS,
  FETCH_COMPANY_FAIL,
  SAVE_COMPANY_KIOSK_ID,
} from '../../constants/action_types';

const defaultState = {
  id: null,
  name: '',
  code: '',
  logoUrl: null,
  brandColor: '#ffffff',
  employeeIdTypes: [],
  hasFetchedData: false,
  isLoading: false,
  error: '',
  kioskId: null,
};

const companyReducer = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_COMPANY_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case SAVE_COMPANY_KIOSK_ID:
      return {
        ...state,
        kioskId: action.kioskId,
      };
    case FETCH_COMPANY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasFetchedData: true,
        id: action.id,
        name: action.name,
        code: action.code,
        logoUrl: action.logoUrl || '',
        brandColor: action.brandColor,
        employeeIdTypes: action.employeeIdTypes,
        kioskWelcomeText: action.kioskWelcomeText,
        kioskId: action.kioskId,
        error: '',
      };
    case FETCH_COMPANY_FAIL:
      return {
        ...state,
        isLoading: false,
        hasFetchedData: true,
        logoUrl: '',
        error: action.error,
      };
    default:
      return state;
  }
};

export default companyReducer;
